import React, { useEffect, useState } from "react";
import "./App.css";
import LandingPage from "./page/LandingPage";
import { configureFirebase } from "./firebase";
import { useSelector } from "react-redux";
import { useTranslation } from "react-i18next";
import LanguageSelector from "./components/LanguageSelector";
import Footer from "./components/Footer";
import TermsOfUse from "./page/TermsOfUse";
import AboutUs from "./page/AboutUs";
import ScrollToTop from "./components/ScrollToTop";
import History from "./page/History";
import HistoryData from "./page/HistoryData";
import Disclaimer from "./page/Disclaimer";
import {
  BrowserRouter as Router,
  Routes,
  Route,
  Outlet,
  Navigate,
} from "react-router-dom";
import MainCards from "./components/MainCards";
import PrivacyPolicy from "./page/PrivacyPolicy";
import CookieConsent from "./components/CookieConsent";
import i18n from "./i18n";
import Faq from "./page/Faq";
import Blog from "./page/Blog";
import BlogDetail from "./page/BlogDetail";
import Loader from "./components/Loader";
import Settings from './page/Settings'

function App() {
  const { t } = useTranslation();

  const { isAccepted } = useSelector((state) => state.cookie);
  useEffect(() => {
    configureFirebase();
  }, [isAccepted]);
  const [direction, setDirection] = useState("ltr");

  useEffect(() => {
    const rtlLanguages = ["ar", "fa", "ur"];
    const currentLang = i18n.language;

    if (rtlLanguages.includes(currentLang)) {
      setDirection("rtl");
      document.documentElement.setAttribute("dir", "rtl");
    } else {
      setDirection("ltr");
      document.documentElement.setAttribute("dir", "ltr");
    }
  }, [i18n.language]);

  function Layout() {
    return (
      <>
        <div className="flex flex-col min-h-screen">
          <main className="flex-grow">
            <ScrollToTop />
            <Outlet />
            <CookieConsent />
            <Loader />
          </main>
          {/* <GeminiChatbot /> */}
          <Footer />
          {/* <ChatBot /> */}
        </div>
      </>
    );
  }
  return (
    <>
      <Router>
        <Routes>
          <Route path="/" element={<Layout />}>
            <Route index element={<MainCards />} />
            <Route path="history" element={<History />} />
            <Route path="history/:id" element={<HistoryData />} />
            <Route path="privacy-policy" element={<PrivacyPolicy />} />
            <Route path="terms-of-use" element={<TermsOfUse />} />
            <Route path="about-us" element={<AboutUs />} />
            <Route path="disclaimer" element={<Disclaimer />} />
            <Route path="maincards" element={<MainCards />} />
            <Route path="faq" element={<Faq />} />
            <Route path="blog" element={<Blog />} />
            <Route path="settings" element={<Settings />} />
            <Route
              path="calculator/:calculatorType"
              element={<LandingPage />}
            />
            <Route path="blog/:slug" element={<BlogDetail />} />
            {/* <Route path="blog/:id" element={<BlogDetail />} /> */}
          </Route>
          {/* Show home page content at /index.html */}
          <Route path="/index.html" element={<Layout />}>
            <Route index element={<MainCards />} />
          </Route>
        </Routes>
      </Router>
    </>
  );
}

export default App;
